<div class="container">
  <!-- Barra de búsqueda -->
  <div class="search-container">
    <div class="search-row">
      <!-- Campo de búsqueda de texto (incluye ID) -->
      <ion-item class="search-item">
        <ion-input [(ngModel)]="searchText" (ionInput)="applyFilters()"
          placeholder="ID del servicio, dirección, conductor, teléfono, nota..." clearOnEdit="false" debounce="300">
        </ion-input>
      </ion-item>
      <ion-item class="search-item">
        <ion-input [(ngModel)]="searchLicense" (ionInput)="applyFiltersLicense()" placeholder="Licencia"
          clearOnEdit="false" debounce="300">
        </ion-input>
      </ion-item>

      <!-- Select de estado con popover -->
      <ion-item class="status-button">
        <ion-select class="no_icon" interface="popover" [(ngModel)]="searchStatus" (ionChange)="applyFilters()"
          placeholder="Estado">
          <ion-select-option value="">Estados</ion-select-option>
          <ion-select-option value="activos">Activos</ion-select-option>
          <ion-select-option value="cancelados">Cancelados</ion-select-option>
          <ion-select-option value="completados">Completados</ion-select-option>
          <ion-select-option value="otros">Otros</ion-select-option>
        </ion-select>
      </ion-item>

      <!-- Select de tipo de reserva con popover -->
      <ion-item class="status-button">
        <ion-select class="no_icon" interface="popover" [(ngModel)]="searchReserveType" (ionChange)="applyFilters()"
          placeholder="Tipo">
          <ion-select-option value="">Tipos</ion-select-option>
          <ion-select-option value="al-momento">Al momento</ion-select-option>
          <ion-select-option value="reservas">Reservas</ion-select-option>
        </ion-select>
      </ion-item>

      <!-- Botón de búsqueda en BD -->
      <!-- <ion-button (click)="searchInDatabase()" [disabled]="isSearching" color="primary" fill="solid">
        <ion-icon slot="start" name="search"></ion-icon>
        {{ isSearching ? 'Buscando...' : 'Buscar en BD' }}
      </ion-button> -->
    </div>

    <!-- Filtros de fecha -->
    <div class="date-filters">
      <div class="date-filter-item">
        <!-- <ion-label position="stacked">Tipo de fecha</ion-label> -->
        <ion-item>
          <ion-select class="no_icon" interface="popover" [(ngModel)]="searchDateType" (ionChange)="applyFilters()">
            <ion-select-option value="creacion">Fecha creación</ion-select-option>
            <ion-select-option value="reserva">Fecha reserva</ion-select-option>
          </ion-select>
        </ion-item>
      </div>
      <div class="date-filter-item">
        <!-- <ion-label position="stacked">Fecha desde</ion-label> -->
        <ion-item>
          <ion-input type="date" [(ngModel)]="searchFromDate" (ionChange)="applyFilters()">
          </ion-input>
        </ion-item>
      </div>

      <div class="time-filter-item">
        <!-- <ion-label position="stacked">Hora desde</ion-label> -->
        <ion-item>
          <ion-input type="time" [(ngModel)]="searchFromTime" (ionChange)="applyFilters()">
          </ion-input>
        </ion-item>
      </div>

      <div class="date-filter-item">
        <!-- <ion-label position="stacked">Fecha hasta</ion-label> -->
        <ion-item>
          <ion-input type="date" [(ngModel)]="searchToDate" (ionChange)="applyFilters()">
          </ion-input>
        </ion-item>
      </div>

      <div class="time-filter-item">
        <!-- <ion-label position="stacked">Hora hasta</ion-label> -->
        <ion-item>
          <ion-input type="time" [(ngModel)]="searchToTime" (ionChange)="applyFilters()">
          </ion-input>
        </ion-item>
      </div>

      <!-- Botón limpiar filtros -->
      <ion-button (click)="clearFilters()" color="medium" fill="outline" size="small">
        <ion-icon slot="start" name="close-circle"></ion-icon>
        Limpiar
      </ion-button>
    </div>
  </div>

  <!-- Tabla de servicios -->
  <div class="table-container">
    <app-table [columns]="columns" [lines]="paginatedJourneys" [pagination]="totalPages > 1" [currentPage]="page"
      [total]="totalPages" [limit]="limit" (doActionParent)="doActionParent($event)"
      (paginacionParent)="onPageChange($event)">
    </app-table>

    <h2 class="empty_screen" *ngIf="!transformedJourneys.length">
      {{ searchText || searchLicense || searchStatus || searchReserveType || searchFromDate || searchToDate ? 'No se
      encontraron servicios' :
      'Cargando
      servicios...' }}
    </h2>

    <!-- Información de paginación -->
    <div class="pagination-info" *ngIf="transformedJourneys.length > 0">
      Mostrando {{ ((page - 1) * limit) + 1 }} - {{ getPaginationEnd() }} de {{ transformedJourneys.length }} servicios
    </div>
  </div>
</div>